import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import api from "../../../axios";
import Api from "../../../Api";
import { Button, Box, Typography, TextField, Grid } from "@material-ui/core";
import readXlsxFile from "read-excel-file";
import { useParams } from "react-router-dom";
import { AuctionListLimit, getIDset } from "../../../adminModel/auctions";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Alert from "@material-ui/lab/Alert";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";

import chargeSample from './template_update_HP_and_BP.xlsx';

const useStyles =makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  imageList: {
    width: 400,
    height: 250,
    padding: 20,
  },
  table: {
    minWidth: 650,

  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));




export default function View() {
  const classes = useStyles();

  // var { auctionId, setId } = useParams();

  const [loading, setloading] = useState(false);
  const [geteventList, setEventList] = useState([]);
  const [eventId, setEventId] = useState("");
  const [IDset, setID] = useState("");
  const [message, setMessage] = useState("");
  // const [progress, setProgress] = React.useState(0);
  const [details, setDetails] = useState([]);


  const handleChange = (event) => {
    readXlsxFile(event.target.files[0]).then((rows) => {
      console.log("rows", rows);
      setDetails(rows.slice(1));
      // if (rows[0][0] === "Lot number") {
      //  // setDetails(rows.slice(1));
      //    console.log("rows", rows);
      // } else {
      //   setMessage("WRONG FORMAT HEADER!");
      // }
    });
  };

  // function LoadingBar() {
  //   const timer = setInterval(() => {
  //     setProgress((prevProgress) =>
  //       prevProgress >= 100 ? 10 : prevProgress + 10
  //     );
  //   }, 400);
  //   return () => {
  //     // setloading(true);
  //     window.clearInterval(timer);
  //   };
  // }

  const submitHandler = async (e) => {
    e.preventDefault();
    setloading(true);
    // console.log("filesImage: ",filesImage[0]);
    //http://157.230.43.47:3000/api/auction_set?auction_id=69

    var success = 0;
    let promiseArray = details.map((data) => {
      // formData.append('files',data[2]);
      const DataArray = {
        auction_id: eventId,
        set_id: IDset,
        lot_number: data[0],
        hp: data[1],
        bp: data[2],
      };

      console.log("DataArray: ", DataArray);
      let config = {
        method: "put",
        maxBodyLength: Infinity,
        url: `${Api.request.URL}/lot/hp`,
        data: DataArray,
      };

      return api
        .request(config)
        .then((response) => {
          success++;
          const filteredBooks = details.filter((val) => val.includes(data[0]));
          //setSuccessMessage((list) => [...list, response.data.msg]);
          const extendedSet = filteredBooks[0].push(
            response.data.msg,
            "success"
          );
          setDetails(extendedSet);
          setloading(false)
        })
        .catch((error) => {
          const filteredBooks = details.filter((val) => val.includes(data[0]));
          const extendedSet = filteredBooks[0].push(
             error.response.data.msg,
             "error"
          );
          setloading(false)
          setDetails(extendedSet);
          // setSuccessMessage((list) => [...list, error.response.data.msg]);
          // console.log(data[0] + " " + error.response.data.msg);
        });
    });
    Promise.all(promiseArray).then(() => {
      // setCountSuccess(0);
      setDetails(details);
      console.log("merged: ", details);
      console.log("Message: Success ", success);
    });
  };

  useEffect(() => {
    async function fetchData() {
      setloading(true);
      const results = await AuctionListLimit();
      // console.log(results.data);
      setloading(false);
      setEventList(results.data);
    }
    fetchData().catch(console.error);
  }, []);

  const handlepick = (e, v) => {
    // e.preventDefault();
    try {
      setEventId(v.id);
      return getSetID(v.id);
    } catch (error) {
      setEventId("");

      // setEventId("");
      console.log("error");
    }
    // setEventId(v.id=);
  };

  const getSetID = (eventID) => {
    // setEmail(email)
    async function dataSetID() {
      const results = await getIDset(eventID);
      setID(results[0].id);
      // console.log('results: ',results[0].id)
    }
    dataSetID().catch(console.error);
  };



  

  return (
    <div>
      <Box style={{ paddingBottom: 30 }}component={Paper}>
        <Grid container spacing={3} style={{ paddingBottom: 20 ,padding:10}}>
          <Grid item md={3} xs={12}>
            <Autocomplete
              required={true}
              disablePortal
              id="combo-box-demo"
              getOptionLabel={(option) => (option ? option.auction_name : "")}
              onChange={(e, v) => {
                handlepick(e, v);
              }}
              options={geteventList}
              sx={{ width: 300 }}
              renderInput={(params) => (
                <TextField {...params} label="Event" variant="outlined" />
              )}
            />
          </Grid>

          <Grid item md={3} xs={12}>
            <TextField
              type="file"
              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              multiple
              name="file"
              variant="outlined"
              //onChange={(e) => setImgSrc(e.target.files[0])}
              onChange={handleChange}
            />
          </Grid>
          <Grid item md={3} xs={12}>
            <Button
              fullWidth={true}
              onClick={submitHandler}
              color="primary"
              variant="outlined"
              style={{ height: "55px" }}
              // disabled={status === STATUS_UPLOADING}
            >
              Update All
            </Button>

            {/* {successMessage.map((val, i) => (
              <Typography key={i}>{val}</Typography>
            ))} */}
          </Grid>

          <Grid item md={3} xs={12}>
            <Button
              fullWidth={true}
              onClick={(e) => {
                e.preventDefault();
                window.location.href=chargeSample;
                }}
              color="primary"
              variant="outlined"
              style={{ height: "55px" }}
              // disabled={status === STATUS_UPLOADING}
            >
              Download Template
            </Button>

           
          </Grid>

        </Grid>
      </Box>
      

      <TableContainer component={Paper} style={{marginTop: 20}}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="left">Lot No</TableCell>
              <TableCell align="left">Hammer Price</TableCell>
              {/* <TableCell align="left">Title</TableCell> */}
              <TableCell align="left">Buyers Premium</TableCell>
              <TableCell align="left">Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {details.length ? (
              details.map((row) => {
                // console.log(row.concat(successMessage));
                return (
                  <TableRow key={row[0]}>
                    <TableCell align="center" component="th" scope="row">
                      {row[0]}
                    </TableCell>
                    <TableCell align="left">{row[1]}</TableCell>
                    <TableCell align="left">{row[2]}</TableCell>
                    {/* <TableCell align="left">{row[3]}</TableCell> */}
                    {/* <TableCell align="left">{row[4]}</TableCell> */}
                    <TableCell align="center">
                      {row[3] === undefined ? (
                        ""
                      ) : row[4] === "success" ? (
                        <Alert severity="success">{row[3]}</Alert>
                      ) : (
                        <Alert severity="error">{row[3]}</Alert>
                      )}
                    </TableCell>
                  </TableRow>
                );
              })
            ) : (
              <TableRow>
                <TableCell key={1} colSpan={5}>
                  {message}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>


    


    </div>
  );
}
